var map = {
	"./001.png": 1011,
	"./002.png": 1012,
	"./003.png": 1013,
	"./004.png": 1014,
	"./005.png": 1015,
	"./006.png": 1016,
	"./007.png": 1017,
	"./008.png": 1018,
	"./009.png": 1019,
	"./010.png": 1020,
	"./011.png": 1021,
	"./012.png": 1022,
	"./013.png": 1023,
	"./014.png": 1024,
	"./015.png": 1025,
	"./016.png": 1026,
	"./017.png": 1027,
	"./018.png": 1028,
	"./019.png": 1029,
	"./020.png": 1030,
	"./021.png": 1031,
	"./022.png": 1032,
	"./023.png": 1033,
	"./024.png": 1034,
	"./025.png": 1035,
	"./026.png": 1036,
	"./027.png": 1037,
	"./028.png": 1038,
	"./029.png": 1039,
	"./030.png": 1040,
	"./031.png": 1041,
	"./032.png": 1042
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2620;



//////////////////
// WEBPACK FOOTER
// ./src/Images/OldCampIcons ^\.\/.*\.png$
// module id = 2620
// module chunks = 0